import { SelectionMode } from '@cadstrom/renderer';
import MouseIcon from '@mui/icons-material/Mouse';

import { DrawingManagerContext } from '../context/drawing-manager-context.js';
import { ToolbarItem } from './toolbar-item.js';

import type { ISelection } from '@cadstrom/renderer';
import type { ElementType } from 'react';
import type { DrawingManagerContextValue } from '../context/drawing-manager-context.js';
import type { IToolbarItem, IToolbarItemState } from './toolbar-item.js';

interface IOwnState extends IToolbarItemState {}

export class SelectionToolbarItem extends ToolbarItem<IOwnState> implements IToolbarItem {
	public static readonly ItemId = 'select';
	id: string = SelectionToolbarItem.ItemId;
	title = 'Select';
	keyEventName = 'SELECT';
	defaultKeyBinding = 's';
	iconElement: ElementType = MouseIcon;
	includeInHistory = true;
	isExclusive = true;
	// @ts-expect-error
	context: DrawingManagerContextValue | undefined;
	private handlersBound = false;

	public onActiveStateChanged(isActive: boolean) {
		if (isActive) {
			this.bindHandlers();
			this.context?.drawingManager?.setSelectionMode(SelectionMode.AnySingleNetOrObject);
		} else {
			this.unbindHandlers();
			this.context?.drawingManager?.setSelectionMode(SelectionMode.None);
			this.context?.drawingManager?.interactionState?.clearSelection();
		}
	}

	public override componentWillUnmount(): void {
		this.unbindHandlers();
		super.componentWillUnmount();
	}

	private readonly selectionChanged = (selection: ISelection) => {
		this.emitToolUsed(selection);
	};

	private bindHandlers() {
		if (!this.handlersBound) {
			this.context?.drawingManager?.on('selectionChanged', this.selectionChanged);
			this.handlersBound = true;
		}
	}

	private unbindHandlers() {
		if (this.handlersBound) {
			this.context?.drawingManager?.removeListener('selectionChanged', this.selectionChanged);
			this.handlersBound = false;
		}
	}

	public onKeyEvent(): void {
		// Empty on purpose
	}

	public onClick(): void {
		// Empty on purpose
	}
}

SelectionToolbarItem.contextType = DrawingManagerContext;
